import React from 'react';
import PropTypes from 'prop-types';

import { StyledStrikeThrough, StyledSubtotal, StyledSubtotalAmount, StyledInfo, StyledSticky, StyleButtonWrapper, StyledButton } from './CartDrawerStickyButtonWrapperStyles';
import CartDiscountAlt from '../CartDiscountAlt/CartDiscountAlt';

import { getCurrency } from '../../Utils/PriceUtils';

var _ref = React.createElement(
  'p',
  null,
  'Subtotal:'
);

var _ref2 = React.createElement(
  StyledInfo,
  null,
  'Shipping + Taxes Calculated at Checkout'
);

var CartDrawerStickyButtonWrapper = function CartDrawerStickyButtonWrapper(props) {
  var showFullSubtotal = props.checkout.subtotalPriceV2.amount != props.checkout.lineItemsSubtotalPrice.amount;

  var checkoutSubtotal = getCurrency(props.checkout.subtotalPriceV2.currencyCode, props.checkout.subtotalPriceV2.amount);
  var lineItemsSubtotal = getCurrency(props.checkout.lineItemsSubtotalPrice.currencyCode, props.checkout.lineItemsSubtotalPrice.amount);

  var openCheckout = function openCheckout(webUrl) {
    // Strip the domain to use same domain as present
    var relativeUrl = webUrl.replace('https://dormifyplus.myshopify.com', '');
    window.location.href = relativeUrl;
  };

  return React.createElement(
    StyledSticky,
    null,
    React.createElement(
      StyledSubtotal,
      null,
      _ref,
      React.createElement(
        StyledSubtotalAmount,
        null,
        React.createElement(
          'p',
          null,
          checkoutSubtotal
        ),
        showFullSubtotal && React.createElement(
          StyledStrikeThrough,
          null,
          lineItemsSubtotal
        )
      )
    ),
    _ref2,
    React.createElement(CartDiscountAlt, {
      addDiscountCode: props.addDiscountCode,
      removeDiscountCode: props.removeDiscountCode,
      discountCode: props.checkoutDiscountCodes && props.checkoutDiscountCodes.edges[0],
      autoDiscountPromo: props.autoDiscountPromo,
      autoDiscountCode: props.autoDiscountCode,
      autoDiscountCodeEndDate: props.autoDiscountCodeEndDate,
      formSubmitted: props.formSubmitted,
      formDiscountCode: props.formDiscountCode
    }),
    React.createElement(
      StyleButtonWrapper,
      { isCartOpen: props.isCartOpen },
      React.createElement(
        StyledButton,
        {
          className: 'btn btn--full gradient-shimmer btn--proceed-to-checkout',
          disabled: props.cartQuantity === 0,
          onClick: function onClick() {
            return openCheckout(props.checkout.webUrl);
          }
        },
        'Proceed To Checkout'
      )
    )
  );
};

CartDrawerStickyButtonWrapper.propTypes = {
  checkout: PropTypes.object.isRequired,
  webUrl: PropTypes.string,
  cartQuantity: PropTypes.number,
  handleCartClose: PropTypes.func,
  addCheckoutNote: PropTypes.func.isRequired,
  checkoutNote: PropTypes.string,
  addPlusReleaseDate: PropTypes.func.isRequired,
  checkoutCustomAttributes: PropTypes.array,
  noVendorItems: PropTypes.bool,
  addDiscountCode: PropTypes.func.isRequired,
  removeDiscountCode: PropTypes.func.isRequired,
  checkoutDiscountCodes: PropTypes.object,
  autoDiscountPromo: PropTypes.bool,
  autoDiscountCode: PropTypes.string,
  autoDiscountCodeEndDate: PropTypes.string,
  formSubmitted: PropTypes.bool,
  formDiscountCode: PropTypes.string,
  discountThresholdAmount: PropTypes.string
};

export default CartDrawerStickyButtonWrapper;